import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import Menu from "@engineering/icons/menu";
import React from "react";
import { useTheme } from "@emotion/react";
import { IconButtonContainer } from "../Header.styles";
import { List } from "./HiddenLinksPopover.styles";
var HiddenLinksPopover = function(param) {
    var children = param.children;
    var spacing = useTheme().spacing;
    return /*#__PURE__*/ _jsx(Ui.Popover, {
        button: {
            as: "div",
            children: /*#__PURE__*/ _jsx(IconButtonContainer, {
                children: /*#__PURE__*/ _jsx(Ui.IconButton, {
                    icon: Menu,
                    size: "medium"
                })
            }, "actionButton-hiddenLinks")
        },
        triggerAction: "click",
        children: /*#__PURE__*/ _jsx(Ui.PopoverPanel, {
            children: /*#__PURE__*/ _jsx(Ui.PanelContentWrapper, {
                padding: spacing[50],
                width: "255px",
                children: /*#__PURE__*/ _jsx(List, {
                    children: children
                })
            })
        })
    });
};
export { HiddenLinksPopover };
